var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"h-8 img__wrapper sm:bg-white sm:p-4 sm:h-full sm:inline-block",attrs:{"href":_vm.href}},[_c('img',{attrs:{"height":"auto","width":"auto","src":require(("@/assets/images/" + _vm.src)),"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }